import z from "zod";

const deviceLocationDataSchema = z.object({
    ip: z.string().nullable(),
    code: z.string().nullable(),
    chargeId: z.string().nullable(),
    deviceSerial: z.string(),
    location: z.object({
        new: z.object({ latitude: z.number(), longitude: z.number(), timestamp: z.number() }),
        old: z.object({ latitude: z.number(), longitude: z.number(), timestamp: z.number() }).nullable(),
    }),
});

// Also validates the v1 payload, which is only { memory }. The keys v1 omits therefore need .nullish() —
// it accepts a missing key as well as a null one, where .nullable() would reject the whole v1 object.
// Normalization never backfills these to null for a v1 event, so downstream, undefined on this event type
// means either "this arrived as v1" or "the backend sent a valid absent value" — deliberately not
// distinguished, since every renderer already treats both the same way via `?? unknown`.
const deviceMemoryDataSchema = z.object({
    ip: z.string().nullish(),
    code: z.string().nullish(),
    chargeId: z.string().nullish(),
    deviceSerial: z.string().optional(),
    memory: z.object({ new: z.string(), old: z.string().nullable() }),
});

const deviceBatteryHealthDegradedDataSchema = z.object({
    deviceSerial: z.string(),
    chargeId: z.string().nullable(),
    code: z.string().nullable(),
    health: z.object({ old: z.string().nullable(), new: z.string() }),
    battery_snapshot: z
        .object({
            status: z.string().optional(),
            plugged: z.string().optional(),
            voltage: z.number().optional(),
            percentage: z.number().optional(),
            temperature: z.number().optional(),
        })
        .optional(),
});

const deviceDataSchema = z.object({
    ip: z.string().nullable(),
    code: z.string().nullable(),
    chargeId: z.string().nullable(),
    deviceSerial: z.string(),
});

// Also validates the v1 payload, which is only { emteriaVersion } — see deviceMemoryDataSchema above,
// including the note on why an undefined field here is left ambiguous between "v1" and "validly absent".
const deviceUpdatedDataSchema = z.object({
    ip: z.string().nullish(),
    code: z.string().nullish(),
    chargeId: z.string().nullish(),
    deviceSerial: z.string().optional(),
    emteriaVersion: z.object({ new: z.string(), old: z.string().nullable() }),
});

export {
    deviceBatteryHealthDegradedDataSchema,
    deviceDataSchema,
    deviceLocationDataSchema,
    deviceMemoryDataSchema,
    deviceUpdatedDataSchema,
};
